module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "stages-matching"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticClass: "component-name"
  }, [_vm._v(_vm._s(_vm.$t('integrations.title.stages_matching')))]), _c('a', {
    staticClass: "collapse-button",
    class: {
      'bloqued': _vm.pipelines.length == 0 && _vm.integration_stages.length == 0 && !_vm.integration_no_stages_api
    },
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#multiCollapse2",
      "aria-expanded": "false",
      "aria-controls": "multiCollapse2"
    }
  }, [_vm._v(_vm._s(_vm.$t('integrations.actions.view.stages_matching'))), _c('span', {
    staticClass: "gray-bold-caret"
  })]), _c('hr')])]), _c('div', {
    staticClass: "collapse multi-collapse",
    attrs: {
      "id": "multiCollapse2"
    }
  }, [(_vm.current_user.isManager()) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('dropdown-select', {
    attrs: {
      "options": _vm.users_options,
      "fullWidth": true
    },
    model: {
      value: (_vm.user_stage_setting),
      callback: function($$v) {
        _vm.user_stage_setting = $$v
      },
      expression: "user_stage_setting"
    }
  })], 1)]), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "checkbox-inline",
    staticStyle: {
      "display": "flex"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleUpdateAllUsers()
      }
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.update_all_users
    }
  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.checkbox.updateAllUsers')))])])])])]) : _vm._e(), (_vm.pipelines && _vm.pipelines.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('integrations.label.stages_matching.funnel')))]), _c('dropdown-select', {
    attrs: {
      "options": _vm.pipelines,
      "fullWidth": true
    },
    on: {
      "input": _vm.updateStages
    },
    model: {
      value: (_vm.selected_pipeline),
      callback: function($$v) {
        _vm.selected_pipeline = $$v
      },
      expression: "selected_pipeline"
    }
  })], 1)])]) : _vm._e(), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(0), _vm._l((_vm.stage_options), function(stage) {
    return (!stage.ignore) ? _c('div', {
      key: stage.value.stage_query,
      staticClass: "form-group item"
    }, [_c('input', {
      staticClass: "form-control draggable",
      class: stage.type,
      attrs: {
        "type": "text",
        "disabled": "disabled",
        "placeholder": stage.text
      }
    })]) : _vm._e()
  })], 2), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('strong', [_vm._v(_vm._s(_vm.integration_name))])]), (_vm.integration_no_stages_api) ? _c('div', _vm._l((_vm.matching), function(field) {
    return _c('div', {
      key: field.reev,
      staticClass: "form-group item"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (field.integration),
        expression: "field.integration"
      }],
      staticClass: "form-control",
      attrs: {
        "placeholder": ((_vm.$t('integrations.placeholder.stages_matching')) + " " + (_vm.integration_name.toUpperCase()))
      },
      domProps: {
        "value": (field.integration)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(field, "integration", $event.target.value)
        }, _vm.updateProps]
      }
    })])
  }), 0) : (_vm.integration_stages_options.length > 0) ? _c('div', _vm._l((_vm.matching), function(field, index) {
    return _c('div', {
      key: index,
      staticClass: "form-group item"
    }, [_c('dropdown-select', {
      attrs: {
        "options": _vm.integration_stages_options,
        "selected": field.integration,
        "fullWidth": true
      },
      on: {
        "input": _vm.updateProps
      },
      model: {
        value: (field.integration),
        callback: function($$v) {
          _vm.$set(field, "integration", $$v)
        },
        expression: "field.integration"
      }
    })], 1)
  }), 0) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('strong', [_vm._v("Reev")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a5324848!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/configuration/integrations/stages_matching.vue
// module id = 1196
// module chunks = 1